import React, { useMemo, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { TPropertiesOfPatchChangesForDish } from 'types';
import { properties } from 'appConstants/dishes';
import { MultipleSelect } from './MultipleSelect';
import SelectedItem from 'components/SelectedItem/SelectedItem';
import style from './index.module.scss';

interface IProps {
	setProperties: (value: TPropertiesOfPatchChangesForDish[]) => void;
	selectedProperties: TPropertiesOfPatchChangesForDish[];
	isCreatedOnPos: boolean;
	hasPortions: boolean;
}

export const PropertiesMultipleSelect: React.FC<IProps> = React.memo(
	({ setProperties, selectedProperties, isCreatedOnPos, hasPortions }) => {
		const { t } = useTranslation('form');

		const fieldsToDisable = new Set(['price']);

		const translatedProperties = useMemo(() => {
			return properties
				.filter((p) => (!isCreatedOnPos && !hasPortions) || !fieldsToDisable.has(p.id))
				.map((p) => ({
					id: p.id,
					name: t(p.name),
				}));
		}, [isCreatedOnPos, hasPortions, t]);

		const handleRemove = useCallback(
			(id: string) => {
				const updatedSelectedItems = selectedProperties.filter((el) => el !== id);
				setProperties(updatedSelectedItems);
			},
			[selectedProperties, setProperties],
		);

		const restaurantsList = useMemo(() => {
			return selectedProperties.map((el) => {
				const label = translatedProperties?.find((item) => item.id === el)?.name || '';

				return <SelectedItem key={el} label={label} onDelete={() => handleRemove(el)} />;
			});
		}, [selectedProperties, translatedProperties, handleRemove]);

		return (
			<div className={style.container} data-test="PropertiesMultipleSelect">
				<MultipleSelect
					setProperties={setProperties}
					properties={translatedProperties}
					selectedProperties={selectedProperties}
				/>
				<div className={style.groupsList}>{restaurantsList}</div>
			</div>
		);
	},
);
